import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { changeWorkflowFilter, fetchWorkflows } from '../actions';
import { selectItemsCount, selectPaginator, selectWorkflows, selectWorkflowsFilter } from '../selectors';
import { HBox, VBox } from '../../../components/Box';
import { WorkflowsSearch } from '../components/Search';
import { Button } from '../../../components/Buttons';
import { WorkflowsOverviewTable } from '../components/WorkflowsOverviewTable';
import { Pagination } from '../../../components/Pagination';
import { REQUEST_WORKFLOWS } from '../constants';
import { selectWorks } from '../../Api/selectors';
import { Loader } from '../../../components/Loader';
import { WORKFLOW_CRUD } from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import { PageHeader } from '../../../components/PageHeader';
import { ChevronRight } from '../../../components/Icon';

const Container = styled.div`
  .form-controlField {
    margin-bottom: 0;
  }
  .filters {
    padding: 24px;
    background-color: white;
    margin-bottom: 22px;
  }
`;

const STATE = {
  currentPage: 0,
};

/* eslint-disable react/prefer-stateless-function */
class WorkflowsOverviewComp extends BaseComponent {
  constructor(props) {
    super(props, STATE);
  }

  componentDidMount() {
    this.props.fetch();
  }

  selectPage = newPage => {
    if (newPage === this.state.currentPage) return;
    const newOffset = this.props.paginator.limit ? newPage * this.props.paginator?.limit : newPage * 50;
    this.setState({ currentPage: newPage }, this.props.changeFilter('offset', newOffset));
  };

  onClickCreateBtn() {
    return this.to(`/workflows/new`);
  }

  render() {
    if (this.props.work || !this.props.filter) return <Loader small />;
    return (
      <Permission permission={WORKFLOW_CRUD}>
        <Container>
          <PageHeader
            title={
              <>
                {this.lbl('workflows.overview.itemsCount')} <span className="label number">{this.props.count}</span>
              </>
            }
            breadCrumbs={
              <>
                <a href="/">Vindat</a>
                <ChevronRight />
                {this.lbl('workflows.overview.itemsCount')}
              </>
            }
          />

          <div className="filters">
            <HBox right>
              <Button primary small onClick={this.onClickCreateBtn.bind(this)}>
                +{this.lbl('add')}
              </Button>
            </HBox>
            <VBox left vCenter>
              <WorkflowsSearch />
            </VBox>
          </div>

          <div>
            <WorkflowsOverviewTable />
          </div>
          {this.props.paginator?.itemsCount > this.props.paginator?.limit && (
            <Pagination paginator={this.props.paginator} selectPage={this.selectPage} />
          )}
        </Container>
      </Permission>
    );
  }
}

WorkflowsOverviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workflows: selectWorkflows(),
    paginator: selectPaginator(),
    count: selectItemsCount(),
    work: selectWorks([REQUEST_WORKFLOWS]),
    filter: selectWorkflowsFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(fetchWorkflows());
    },
    changeFilter: (name, value) => {
      dispatch(changeWorkflowFilter(name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WorkflowsOverview = compose(withConnect, withRouter)(WorkflowsOverviewComp);
